export const calculateSaleAmount = ({ cost, profitMargin, profitMarginType }) => {
    let saleAmount = Number(cost);
    if (profitMarginType === "PERCENTAGE") {
        saleAmount = Number(cost || 0) * ((parseFloat(profitMargin || 0) / 100) + 1);
    } else if (profitMarginType === "FIXED") {
        saleAmount = Number(cost || 0) + parseFloat(profitMargin || 0);
    }
    return Number(saleAmount.toFixed(2));
};